import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.uploadModel;

const uploadModelData = createSelector([selector], (state) => state);

export default {
  uploadModelData
};
